export default "<p>enterprise-admin works!</p>\n"